import IncidentSummary from '../incident-summary';

<IncidentSummary
  summary="A platform instability between August 11 and August 13, 2026 caused incomplete analytics event collection for some campaigns."
  status="resolved"
  startedAt="2026-08-11T19:00:00-03:00"
  resolvedAt="2026-08-13T09:00:00-03:00"
/>

## What happened

On August 11, 2026, the server responsible for collecting event data (impressions, clicks, and others) from your app became temporarily unavailable. As a result, it temporarily stopped recording some of the events it received.

## How this affects you

If you sent a campaign between **August 11 and 13**, the impression and click numbers shown for those campaigns may be **partially or fully incomplete**. The campaigns themselves were delivered normally to your users — the issue affected only our ability to **track and report** that data, not our ability to **send** campaigns.

Your app's end users were **not affected at any point** and noticed nothing different — the incident was limited to our internal data collection system and had no visible impact on their experience.

There was no interruption to orders placed within the app, and your customers' shopping experience did not change at any point. This incident **did not affect** your store's systems, including orders, payments, or any related functionality — the impact was limited exclusively to campaign tracking data.

## What we did

We identified the root cause, restored availability of the affected server, and resumed normal event collection.

## What you should do

- For campaigns sent during this period, treat impression/click numbers as **incomplete**, not as zero.
- No action is required on your part — the problem was entirely on our infrastructure.
- If you use this data in reports for your stakeholders, we recommend flagging campaigns from this period as having partial data.

## What we are doing to prevent this from happening again

We are implementing automated monitoring and alerts on this server to identify and resolve availability issues before they affect data collection.

---
We apologize for any inconvenience this may have caused. If you have questions about a specific campaign's data, contact our support team — we will be happy to help assess the impact.
